import { render, staticRenderFns } from "./SalesProjectionTable.vue?vue&type=template&id=32c6b89b&scoped=true&"
import script from "./SalesProjectionTable.vue?vue&type=script&lang=js&"
export * from "./SalesProjectionTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c6b89b",
  null
  
)

export default component.exports